import { BrazeClient } from "./client";

const sdkEndpoint = "sdk.iad-07.braze.com";

export type BrazeSDK = {
  initialize: (
    apiKey: string,
    config: {
      allowUserSuppliedJavascript: boolean; // set to `true` to support custom HTML messages
      baseUrl: string;
      enableLogging: boolean;
    },
  ) => void;
  openSession: () => void;
  logCustomEvent: (name: string, properties?: Record<string, unknown>) => void;
};

declare global {
  var braze: BrazeSDK | undefined;
}

const Braze = (apiKey: string | undefined, source: string | undefined) => (
  <BrazeClient apiKey={apiKey} src={source} />
);
Braze.init = (apiKey: string) => {
  globalThis.braze?.initialize(apiKey, {
    allowUserSuppliedJavascript: false, // set to `true` to support custom HTML messages
    baseUrl: sdkEndpoint,
    enableLogging: false, // set to `true` for debugging
  });

  // `openSession` should be called last - after `changeUser` and `automaticallyShowInAppMessages`
  type BW = { openSession?: () => void };
  const bw = (globalThis as unknown as { braze?: BW }).braze;
  if (bw && typeof bw.openSession === "function") {
    bw.openSession();
  }
};

export default Braze;
